import API from './api';

export const weeklyOffService = {
  getSchedules: () => API.get('/weekly-offs/schedules'),
  createSchedule: (data) => API.post('/weekly-offs/schedules', data),
  updateSchedule: (id, data) => API.put(`/weekly-offs/schedules/${id}`, data),
  deleteSchedule: (id) => API.delete(`/weekly-offs/schedules/${id}`),

  getAssignments: (params) => API.get('/weekly-offs/assignments', { params }),
  createAssignment: (data) => API.post('/weekly-offs/assignments', data),
  deleteAssignment: (id) => API.delete(`/weekly-offs/assignments/${id}`),

  // Weekly off dates + holidays for one employee (defaults to the current user and month)
  getCalendar: (params) => API.get('/weekly-offs/calendar', { params }),
  // { [employeeId]: ['YYYY-MM-DD', ...] } for reports
  getResolved: (params) => API.get('/weekly-offs/resolved', { params }),
};
